import { ECONOMY_SAVINGS_MESSAGE_TEMPLATES, ECONOMY_SAVINGS_METRICS_CONFIG } from './economy-savings.constants';
import { getMetricViewProps } from '../../../../shared/utils/metrics.utils';

const getMessageTemplate = boardName => ECONOMY_SAVINGS_MESSAGE_TEMPLATES[boardName] || '';

const getMessageValue = (boardData, metricName) => {
    const metricData = boardData.find(data => data.metric === metricName);
    const { value } = getMetricViewProps(metricData, ECONOMY_SAVINGS_METRICS_CONFIG);
    return value;
};

export const getMessage = (boardName, boardData) => {
    const messageTemplate = getMessageTemplate(boardName);
    return messageTemplate.replace(/:([a-z]+)/g, (_, metricName) => getMessageValue(boardData, metricName));
};
